import { SxProps } from '@mui/system';

export const mainStyle: SxProps = {
  width: '100vw',
  height: '100vh',
  overflowX: 'hidden',
  backgroundImage: 'linear-gradient(to right, var(--color-background-dark), var(--color-background-light))', 
};
